'use strict';

(function() {
    angular.module('app').service('ComponentTranslations', ComponentTranslations);

    ComponentTranslations.$inject = ['$translate'];

    function ComponentTranslations($translate) {
        var api = {
            multiselect: multiselect,
        };

        function multiselect() {
            var labels = ['select', 'selectAll', 'unselectAll', 'search', 'itemsSelected'];
            var results = {};

            angular.forEach(labels, function(v) {
                results[v] = $translate.instant('general.multiselect.' + v);
            });

            return results;
        }

        return api;
    }
})();
